import axios from "../../config/axiosConfig";

export default {
	generateOrders: (data) => axios.post(`/generate/order`, data, { responseType: "blob" }),
};
